import { table } from './_table';
import { form } from './form';

export const phone_lists = {
  namespaced: true,
  modules: {
    table,
    form
  }
};
